import { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import AlertMessage from "../../Components/Alert/Alert";
import "./subsavings.css";

const SubSavings = () => {
	const [search, setSearch] = useState("");
	const [openDetails, setOpenDetails] = useState(null);
	const [alertParams, setAlertParams] = useState({
		open: false,
		message: "",
		type: "",
	});
	const periods = [
		"Гибкий",
		"1 Неделя",
		"1 Месяц",
		"3 Месяца",
		"6 Месяцев",
		"1 Год",
	];
	const popularSavings = [
		{
			name: "ATOM",
			img: "/icons/atom.svg",
			percents: ["2%", "4%", "8%", "12%", "17%", "20%"],
		},
		{
			name: "SOL",
			img: "/icons/sol.svg",
			percents: ["3%", "7%", "20%", "36%", "44%", "53%"],
		},
		{
			name: "ICP",
			img: "/icons/icp.svg",
			percents: ["3%", "7%", "20%", "36%", "44%", "53%"],
		},
		{
			name: "AUD",
			img: "/icons/aud.svg",
			percents: ["10%", "15%", "18%", "22%", "30%", "45%"],
		},
		{
			name: "BCH",
			img: "/icons/bch.svg",
			percents: ["15%", "21%", "30%", "35%", "50%", "65%"],
		},
		{
			name: "USD",
			img: "/icons/usd.svg",
			percents: ["6%", "7%", "10%", "15%", "25%", "30%"],
		},
		{
			name: "SNX",
			img: "/icons/snx.svg",
			percents: ["3%", "5%", "7%", "10%", "15%", "22%"],
		},
		{
			name: "LINK",
			img: "/icons/link.svg",
			percents: ["3%", "5%", "7%", "10%", "15%", "22%"],
		},
		{
			name: "BNB",
			img: "/icons/bnb.svg",
			percents: ["5%", "10%", "13%", "18%", "20%", "25%"],
		},
		{
			name: "LTC",
			img: "/icons/ltc.svg",
			percents: ["3%", "4%", "7%", "10%", "15%", "30%"],
		},
		{
			name: "USDT",
			img: "/icons/usdt.svg",
			percents: ["7%", "10%", "12%", "18%", "21%", "37%"],
		},
		{
			name: "DOT",
			img: "/icons/dot.svg",
			percents: ["25%", "3%", "6%", "9%", "12%", "24%"],
		},
		{
			name: "XMR",
			img: "/icons/xmr.svg",
			percents: ["2%", "5%", "10%", "20%", "50%", "100%"],
		},
	];
	const handleOpenDetails = (index) => {
		setOpenDetails(openDetails === index ? null : index); // Открыть/закрыть
	};
	const filteredSavings = popularSavings.filter((savings) =>
		savings.name.toLowerCase().includes(search.toLowerCase())
	);
	const handleAlertClose = () => {
		setAlertParams({ ...alertParams, open: false });
	};
	return (
		<div className="sub-savings">
			<AlertMessage
				open={alertParams.open}
				message={alertParams.message}
				type={alertParams.type}
				onClose={handleAlertClose}
			/>
			<div className="sub-savings-header">
				<div className="sub-savings-header-left">
					<h1 className="sub-savings-header-title">Сбережения</h1>
					<p className="sub-savings-header-text">
						Получайте стабильный доход, размещая активы
					</p>
					<p className="sub-savings-header-subtext">
						Популярные сберегательные счета
					</p>
				</div>
				<TextField
					id="search-basic"
					label="Поиск счетов"
					variant="outlined"
					onChange={(e) => setSearch(e.target.value)}
					value={search}
					sx={{ width: "320px" }}
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment position="start">
									<FontAwesomeIcon icon={faMagnifyingGlass} />
								</InputAdornment>
							),
						},
					}}
					placeholder="Поиск"
				/>
			</div>
			<div className="sub-savings-popular">
				{filteredSavings.map((savings, index) => (
					<div key={index} className="sub-savings-popular-item">
						<div className="sub-savings-popular-item-wrapper">
							<div className="sub-savings-popular-item-img">
								<img src={savings.img} alt="savings-icon" />
							</div>
							<p className="sub-savings-popular-item-text">{savings.name}</p>
						</div>
						{openDetails === index && ( // Условный рендеринг
							<div className="sub-savings-popular-item-wrapper">
								<div className="sub-savings-popular-item-text">Продолжительность:</div>
								<div className="sub-savings-popular-item-percents">
									{savings.percents.map((percent, i) => (
										<div key={i} className="sub-savings-popular-item-percents-wrapper">
											<Checkbox
												sx={{ p: 0 }}
												onClick={(e) => {
													e.preventDefault(); // Предотвращаем стандартное поведение
													setAlertParams({
														open: true,
														message: "Необходимо пополнить счет",
														type: "error",
													});
												}}
											/>
											<div className="sub-savings-popular-item-percents-item">
												<p className="sub-savings-popular-item-period">{periods[i]}</p>
												<p className="sub-savings-popular-item-percent">{percent}</p>
											</div>
										</div>
									))}
								</div>
							</div>
						)}
						<Button variant="contained" onClick={() => handleOpenDetails(index)}>
							{openDetails === index ? "Скрыть" : "Открыть счёт"}
						</Button>
					</div>
				))}
				{filteredSavings.length === 0 && (
					<p className="sub-savings-no-results">Ничего не найдено</p>
				)}
			</div>
		</div>
	);
};

export default SubSavings;
